const WEB_PLATFORMS = {
  ios: 'ios',
  android: 'android',
  windows: 'windows',
  unknown: 'unknown',
};

const isIos = () =>
  [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ].includes(navigator.platform) ||
    // iPad on iOS 13 detection
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

/**
 * Determine the mobile operating system.
 * This function returns one of 'ios', 'android', 'windows', or 'unknown'.
 *
 * @returns {String}
 */
const getMobileOperatingSystem = () => {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return WEB_PLATFORMS.windows;
  }

  if (/android/i.test(userAgent)) {
    return WEB_PLATFORMS.android;
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return WEB_PLATFORMS.ios;
  }

  return WEB_PLATFORMS.unknown;
};

const isMobile = () => {
  if (window.cordova && window.device && window.device.platform !== 'browser') {
    return true;
  } else if (window.matchMedia('only screen and (max-width: 760px)').matches) {
    return true;
  }

  return false;
};

export { isIos, isMobile, getMobileOperatingSystem, WEB_PLATFORMS };



// WEBPACK FOOTER //
// ./src/helpers/common.js